<template>
  <div id="app">
    <!-- <Top :clicks="clicks"></Top> -->
    <router-view></router-view>
  </div>
</template>

<script>
  import Top from './components/Top'

  export default {
    name: 'App',
    components: {Top},
    data(){
      return {
        clicks:'',
      }
    },
    mounted() {

    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    background: #f2f2f2;
    padding: 20px 10px;
    min-width: 1024px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue